export default function Battery(props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M39 18L40.5 18C41.3284 18 42 18.8954 42 20L42 24C42 25.1046 41.3284 26 40.5 26H39L39 18Z" fill="white" />
            <rect x="4" y="12" width="33" height="20" rx="1" stroke="white" strokeWidth="2" />
            <rect x="7" y="15" width="6" height="14" fill="white" />
            <rect x="15" y="15" width="6" height="14" fill="white" />
            <rect x="23" y="15" width="6" height="14" fill="white" />
        </svg>
    );
}
